import { TableFilterCheckboxSelect } from '@dealstack/frontend/shared/components/Table/MantineTable/TableFilterCheckboxSelect';
import { ExtendedColumn } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';

interface Props {
	column: ExtendedColumn<unknown>;
	filterText?: string;
}

export const CapTableSelect = ({ column, filterText }: Props) => {
	return <TableFilterCheckboxSelect column={column} filterText={filterText} />;
};
